"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomSelect = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
var _Icon = require("../Icon");
var _CustomOption = require("./CustomOption");
var _excluded = ["children", "customLabel", "disabled", "error", "iconStyles", "inputStyles", "inputWrapperStyles", "label", "labelStyles", "loading", "onBlur", "onChange", "onFocus", "onOpen", "searchOptions", "selectOptionsStyles", "sortOptions", "value"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var defaultSearchOptions = function defaultSearchOptions(_ref, searchValue) {
  var children = _ref.children;
  if ((0, _lodash.isEmpty)(searchValue) || !(0, _lodash.isString)(searchValue) || !(0, _lodash.isString)(children)) {
    return true;
  }
  return children === null || children === void 0 ? void 0 : children.toUpperCase().includes(searchValue === null || searchValue === void 0 ? void 0 : searchValue.toUpperCase());
};
var defaultSortOptions = function defaultSortOptions(children) {
  return children;
};

// When the internal value changes, update the displayed search value accordingly
var getSearchValueForValue = function getSearchValueForValue(value, allOptions) {
  var _allOptions$find, _allOptions$find$prop;
  return value ? (_allOptions$find = allOptions.find(function (child) {
    var _child$props;
    return (child === null || child === void 0 ? void 0 : (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.value) === value;
  })) === null || _allOptions$find === void 0 ? void 0 : (_allOptions$find$prop = _allOptions$find.props) === null || _allOptions$find$prop === void 0 ? void 0 : _allOptions$find$prop.children : '';
};
var getHighlightedIndexForValue = function getHighlightedIndexForValue(value, allOptions) {
  return value ? allOptions === null || allOptions === void 0 ? void 0 : allOptions.findIndex(function (child) {
    var _child$props2;
    return (child === null || child === void 0 ? void 0 : (_child$props2 = child.props) === null || _child$props2 === void 0 ? void 0 : _child$props2.value) === value;
  }) : null;
};
var getAllOptionsKey = function getAllOptionsKey(allOptions) {
  return allOptions.map(function (option) {
    return option.props.value;
  }).join();
};

// Should be kept in sync with the value in SelectInput.styles
var CLOSE_OPTIONS_TRANSITION_TIME = 100;

// TODO: implement contained styles
var CustomSelect = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var allOptions = _ref2.children,
    customLabel = _ref2.customLabel,
    disabled = _ref2.disabled,
    error = _ref2.error,
    iconStyles = _ref2.iconStyles,
    inputStyles = _ref2.inputStyles,
    inputWrapperStyles = _ref2.inputWrapperStyles,
    label = _ref2.label,
    labelStyles = _ref2.labelStyles,
    loading = _ref2.loading,
    _ref2$onBlur = _ref2.onBlur,
    onBlur = _ref2$onBlur === void 0 ? _lodash.noop : _ref2$onBlur,
    onChange = _ref2.onChange,
    _ref2$onFocus = _ref2.onFocus,
    onFocus = _ref2$onFocus === void 0 ? _lodash.noop : _ref2$onFocus,
    _ref2$onOpen = _ref2.onOpen,
    onOpen = _ref2$onOpen === void 0 ? _lodash.noop : _ref2$onOpen,
    _ref2$searchOptions = _ref2.searchOptions,
    searchOptions = _ref2$searchOptions === void 0 ? defaultSearchOptions : _ref2$searchOptions,
    selectOptionsStyles = _ref2.selectOptionsStyles,
    _ref2$sortOptions = _ref2.sortOptions,
    sortOptions = _ref2$sortOptions === void 0 ? defaultSortOptions : _ref2$sortOptions,
    value = _ref2.value,
    props = _objectWithoutProperties(_ref2, _excluded);
  // Refers to text value shown in editable input
  var _useState = (0, _react.useState)(getSearchValueForValue(value, allOptions)),
    _useState2 = _slicedToArray(_useState, 2),
    searchValue = _useState2[0],
    setSearchValue = _useState2[1];
  var _useState3 = (0, _react.useState)(allOptions),
    _useState4 = _slicedToArray(_useState3, 2),
    options = _useState4[0],
    setOptions = _useState4[1];
  // Refers to index of option highlighted in options menu
  var _useState5 = (0, _react.useState)(getHighlightedIndexForValue(value, allOptions)),
    _useState6 = _slicedToArray(_useState5, 2),
    highlightedIndex = _useState6[0],
    setHighlightedIndex = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isShowingOptions = _useState8[0],
    setIsShowingOptions = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState9, 2),
    shouldSpaceBarAddToSearchValue = _useState10[0],
    setShouldSpaceBarAddToSearchValue = _useState10[1];
  var menuRef = (0, _react.useRef)();
  var highlightedRef = (0, _react.useRef)();
  var filterOptions = function filterOptions() {
    var filterValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : searchValue;
    return sortOptions(allOptions.filter(function (child) {
      return searchOptions(child.props, filterValue);
    }), filterValue);
  };
  var resetOptions = function resetOptions(currentValue) {
    setOptions(allOptions);
    if (currentValue) {
      setHighlightedIndex(getHighlightedIndexForValue(currentValue, allOptions));
    } else {
      setHighlightedIndex(null);
    }
  };

  // After new highlightedIndex has been set,
  // center highlighted option vertically in menu
  (0, _react.useEffect)(function () {
    if (menuRef.current && highlightedRef.current && isShowingOptions) {
      // This method ensures that only menu is scrolled
      // instead of whole page (which is what happend with scrollIntoView)
      menuRef.current.scrollTop = highlightedRef.current.offsetTop - menuRef.current.offsetHeight / 2 + highlightedRef.current.offsetHeight / 2;
    }
  }, [highlightedIndex, isShowingOptions]);
  (0, _react.useEffect)(function () {
    onOpen(isShowingOptions);

    // If options have been hidden
    if (!isShowingOptions) {
      // If a valid value was available, update searchValue accordingly
      // Index could be 0, which is falsy
      // Need to check if nil specifically
      var option = options[highlightedIndex];
      if (!(0, _lodash.isNil)(highlightedIndex) && option) {
        setSearchValue(option.props.children);
        onChange(option.props.value, option.props.option);
      }

      // Wait for the CSS transition
      // to hide the menu completely before resetting the options
      setTimeout(function () {
        resetOptions(option === null || option === void 0 ? void 0 : option.props.value);
      }, CLOSE_OPTIONS_TRANSITION_TIME);
    }
  }, [isShowingOptions]);

  // If the list of allOptions changes
  // or more options are created async
  // or value was set programmatically
  (0, _react.useEffect)(function () {
    resetOptions(value);
    var newSearchValue = getSearchValueForValue(value, allOptions);
    if (newSearchValue !== searchValue) {
      setSearchValue(newSearchValue);
    }
  }, [getAllOptionsKey(allOptions), value]);
  var handleOptionMouseDown = function handleOptionMouseDown(index) {
    setHighlightedIndex(index);
    // When options menu closes immediately, it's a little jarring
    // so close options menu after a small delay
    setTimeout(function () {
      return setIsShowingOptions(false);
    }, 500);
  };
  var handleKeyBetweenOptions = function handleKeyBetweenOptions(index) {
    setHighlightedIndex(index);
    setSearchValue(options[index].props.children);
  };
  var disableAddingSpaceBarToSearchValue = (0, _react.useMemo)(function () {
    return (0, _lodash.debounce)(function () {
      setShouldSpaceBarAddToSearchValue(false);
    }, 2000,
    // Wait time to reset Spacebar functionality seems to be a few seconds for native select
    {
      leading: false,
      trailing: true
    } // Begin counting wait time after keypresses have stopped
    );
  }, []);
  var handleKeyDown = function handleKeyDown(e) {
    var key = e.key;
    switch (key) {
      case 'ArrowDown':
      case 'Down':
        {
          if (!isShowingOptions) {
            break;
          }
          // May not change depending on position in options and disabled options
          var newIndex = highlightedIndex;
          var indexToCheck = (0, _lodash.isNil)(newIndex) ? 0 : newIndex + 1;
          while (options[indexToCheck]) {
            if (!options[indexToCheck].props.disabled) {
              newIndex = indexToCheck;
              break;
            }
            indexToCheck += 1;
          }
          handleKeyBetweenOptions(newIndex);
          break;
        }
      case 'ArrowUp':
      case 'Up':
        {
          if (!isShowingOptions || (0, _lodash.isNil)(highlightedIndex)) {
            break;
          }
          // May not change depending on position in options and disabled options
          var _newIndex = highlightedIndex;
          var _indexToCheck = _newIndex - 1;
          while (options[_indexToCheck]) {
            if (!options[_indexToCheck].props.disabled) {
              _newIndex = _indexToCheck;
              break;
            }
            _indexToCheck -= 1;
          }
          handleKeyBetweenOptions(_newIndex);
          // Prevent default behavior of moving cursor to beginning of input
          e.preventDefault();
          break;
        }
      case ' ':
      case 'Spacebar':
        {
          /**
           * In native select elements, Spacebar can expand/close the options menu + select options
           * However, Spacebar can also be used to add onto the searchValue used to filter options
           *
           * In native selects there is a timeout where
           * pressing Spacebar immediately after other characters adds a space to the searchValue
           * and then once the timeout has passed, Spacebar can be used again to expand/close the options menu
           */
          if (!shouldSpaceBarAddToSearchValue) {
            e.preventDefault();
            setIsShowingOptions(!isShowingOptions);
          }
          break;
        }
      case 'Enter':
        {
          if (isShowingOptions) {
            /**
             * If options are showing and input is wrapped in a form,
             * Enter should close the options without submitting the form
             * so prevent the default form action when isShowingOptions is true
             */
            e.preventDefault();
            setIsShowingOptions(false);
          }
          break;
        }
      default:
        {
          // If any other key is pressed, assume user is typing to add to searchValue
          // and signal that Spacebar should add to searchValue
          if (!shouldSpaceBarAddToSearchValue) {
            setShouldSpaceBarAddToSearchValue(true);
          }
          disableAddingSpaceBarToSearchValue();
          break;
        }
    }
  };
  var handleSearch = function handleSearch(e) {
    setIsShowingOptions(true);
    var searchValue = e.target.value;
    setSearchValue(searchValue);
    var options = filterOptions(searchValue);
    setOptions(options);
    // If there are search results and the search input isn't blank,
    // automatically select the first option in the search results
    // to mimic native behavior and also so that component has some value
    // in case user clicks away from/unfocuses the input
    if (options.length && searchValue.length) {
      setHighlightedIndex(0);
      return;
    }
    // If there are no results or user left search input blank,
    // clear the value
    setHighlightedIndex(null);
  };
  var handleFocus = function handleFocus(e) {
    setIsShowingOptions(true);
    onFocus(e);
  };
  var handleBlur = function handleBlur(e) {
    setIsShowingOptions(false);
    onBlur(e);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('flex relative pt-[23px] pb-[6px]', inputWrapperStyles ? '' : 'box-border border-0 border-b border-solid', error ? 'border-alertred-60' : !inputWrapperStyles ? 'border-grey-45' : '', inputWrapperStyles),
    role: "button",
    "aria-expanded": isShowingOptions,
    "aria-haspopup": true
  }, /*#__PURE__*/_react.default.createElement("input", _extends({
    ref: ref,
    type: "text",
    id: (0, _lodash.kebabCase)(label),
    "aria-describedby": "".concat((0, _lodash.kebabCase)(label), "-description"),
    className: (0, _classnames.default)('select-input tw-label-regular w-full peer cursor-text disabled:cursor-not-allowed text-black', inputStyles),
    value: (0, _lodash.isEmpty)(searchValue) ? '' : searchValue,
    disabled: disabled,
    onFocus: handleFocus,
    onBlur: handleBlur,
    onChange: handleSearch,
    onKeyDown: handleKeyDown
  }, props)), loading ? /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: true,
    size: "small",
    className: "absolute right-0 pointer-events-none"
  }) : /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    type: "caret-down-medium-16",
    className: (0, _classnames.default)('absolute right-0 pointer-events-none', iconStyles)
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: (0, _classnames.default)('select-input-label absolute pointer-events-none', searchValue ? 'tw-caption-regular has-value' : 'tw-label-regular', searchValue ? 'top-0' : 'top-[23px]', 'peer-disabled:cursor-not-allowed peer-disabled:text-grey-40', 'peer-focus:tw-caption-regular peer-focus:top-0', {
      'text-grey-45 peer-focus:text-grey-45': !error && !labelStyles && searchValue
    }, labelStyles),
    htmlFor: (0, _lodash.kebabCase)(label)
  }, label), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('select-options absolute top-[calc(100%+1px)] w-full py-[11px]', 'flex flex-col select-none max-h-[260px] overflow-auto', 'shadow-15 rounded-b-[6px] bg-white z-10',
    // Properties that are animated on open/close
    // Set visibility so that elements are non-interactable
    isShowingOptions ? 'visible opacity-100' : 'invisible opacity-0', selectOptionsStyles),
    ref: menuRef
  }, customLabel, options.length ? options.map(function (option, index) {
    var _option$props;
    return /*#__PURE__*/_react.default.cloneElement(option, {
      // On mobile device, there is a silent conflict in handler naming,
      // so we need to pass the payload explicitly
      onMouseDown: function onMouseDown() {
        return handleOptionMouseDown(index);
      },
      isHighlighted: index === highlightedIndex,
      isSelected: (option === null || option === void 0 ? void 0 : (_option$props = option.props) === null || _option$props === void 0 ? void 0 : _option$props.value) === value,
      highlightedRef: highlightedRef,
      index: index
    });
  }) : /*#__PURE__*/_react.default.createElement("p", {
    className: "m-0 text-center"
  }, "No results found.")));
});
exports.CustomSelect = CustomSelect;
CustomSelect.Option = _CustomOption.CustomOption;
CustomSelect.propTypes = {
  children: _propTypes.default.arrayOf(_CustomOption.CustomOption).isRequired,
  inputWrapperStyles: _propTypes.default.string,
  inputStyles: _propTypes.default.string,
  selectOptionsStyles: _propTypes.default.string,
  iconStyles: _propTypes.default.string,
  /**
   * Text for the floating label. Because the styling is fairly complex,
   * no additional styles are currently permitted.
   */
  label: _propTypes.default.string,
  isValidState: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  /**
   * Function used to filter options
   * (Option, searchValue: string) => boolean
   */
  searchOptions: _propTypes.default.func
};